module.exports = __webpack_public_path__ + "img/41.da2abc4b.jpg";